import React from 'react'
import Select from 'react-select';

const DataList = ({ name, value, textLabel, className = '', onChange, dataOptions, required = false }) => {
    return (
        <label className="text-sm font-light flex items-center justify-between">
            <div className='flex'>{textLabel} {required && <span className='text-red-500'>*</span>}</div>
            <div className={`relative inline-flex ${className}`}>
                <Select
                    name={`${name}`}
                    className='w-full'
                    options={dataOptions}
                    placeholder='Seleccione...'
                    // defaultValue={selected}
                    required={required}
                    value={value}
                    styles={{
                        control: (styles) => ({
                            ...styles,
                            border: '1px solid rgb(212 212 216/1)',
                            borderRadius: '0.5rem',
                            fontSize: '0.875rem',
                            lineHeight: '1.25rem',
                            outline: 'none',
                            ':hover': {
                                borderColor: 'rgb(161 161 170/1)'
                            }
                        }),
                        option: (styles, { isSelected }) => ({
                            ...styles,
                            fontSize: '0.875rem',
                            lineHeight: '1.25rem',
                            color: 'rgb(55 65 81 / 1)',
                            backgroundColor: isSelected ? 'rgb(229 231 235 / 1)' : undefined,
                            ':hover': {
                                backgroundColor: 'rgb(229 231 235 / 1)'
                            },
                            ':active': {
                                ...styles[':active'],
                                backgroundColor: isSelected ? 'rgb(229 231 235 / 1)' : undefined
                            }

                        }),
                        input: (styles) => ({
                            ...styles,
                            fontSize: '0.875rem',
                            lineHeight: '1.25rem',
                        }),
                        menu: (styles) => ({
                            ...styles,
                            marginTop: '.2rem',
                        }),
                    }}
                    onChange={onChange}
                />
            </div>
        </label >
    )
}

export default DataList